import React from 'react'
import { localeDate } from '../../../helpers/localeDate'
import { getTimezone } from '../../../helpers/timezone'
import { formatNumber } from '../../../helpers/formatNumber'
import { useSelector } from 'react-redux'
// styles
import Styles from './recentTradesRow.module.css'

function RecentTradesRow({ isAsk, trade }) {
  const theme = useSelector(state => state.theme.value)

  return trade ? (
    <div
      className={`${Styles.rowContainer} ${isAsk ? Styles['sell-row'] : Styles['buy-row']} ${
        theme === 'light' ? Styles.light : ''
      }`}
    >
      <div className={Styles.price}>{formatNumber(trade?.price, 2)}</div>
      <div className={Styles.amount}>{formatNumber(trade?.amount, 5)}</div>
      <div className={Styles.time}>{localeDate(trade?.date ?? trade['created_at'], getTimezone(), 'HH:mm:ss')}</div>
    </div>
  ) : null
}

export default RecentTradesRow
